import CoinbaseIcon from "../../../components/icons/Wallets/Coinbase"
import Phantom from "../../../components/icons/Wallets/Phantom"
import Solflare from "../../../components/icons/Wallets/Solflare"
import WalletConnectIcon from "../../../components/icons/Wallets/WalletConnect"

const KnownSolanaConnectors = [
    {
        id: 'solflare',
        icon: Solflare
    },
    {
        id: 'phantom',
        icon: Phantom
    },
    {
        id: 'walletconnect',
        icon: WalletConnectIcon
    },
    {
        id: 'coinbase',
        icon: CoinbaseIcon
    }
]

export default KnownSolanaConnectors